const Checkout = () => {
	return <div>checkout</div>;
};

export default Checkout;
